import Cookies from 'js-cookie';

export function saveToStorage(n, value) {
    // If we have localStorage available, use it
    if (typeof Storage !== void (0)) {
        let v = window.localStorage.setItem(n, value);
        return true;
    }
    // If no localStorage, fallback to cookies
    Cookies.set(n, value);
    return true;
}
export function getFromStorage(n, fallback = '') {
    // If we have localStorage available, use it
    if (typeof Storage !== void (0)) {
        var v = window.localStorage.getItem(n);
        if (v == null) {
            return fallback;
        }
        return v;
    }
    // If no localStorage, fallback to cookies
    var c = Cookies.get(n);
    if (typeof c == 'undefined') {
        return fallback;
    }
    return c;
}

export default { saveToStorage, getFromStorage };